import React from "react";
import { motion } from "framer-motion";

const founders = [
  {
    name: "Nicolette Matakova",
    image: "/founders/nicolette.jpg",
    bio: "Born and raised in Bulgaria, I developed a deep appreciation for how cultures express themselves through art and design. Studying at Regent's University London expanded my creative perspective through diverse connections and experiences. Later, living in Istanbul for four years sparked my passion for art, architecture, and visual culture. Since returning to London in 2023, I've explored the fashion world as an advisor and stylist for Prada and now Jacquemus, further deepening my love for aesthetics and storytelling.",
  },
  {
    name: "Gizem Ataman",
    image: "/founders/gizem.jpg",
    bio: "I'm a London-based art professional originally from Istanbul, with a background in Art History and Psychology and a master's from The Courtauld Institute of Art. My journey through the art world has taken me from Istanbul to Miami to London, across both commercial and non-profit sectors, giving me a holistic understanding of how different parts of the industry connect. I'm drawn to moments where the local meets the global and the personal intersects with the collective, which continues to shape my passion for fostering cross-cultural dialogue and connecting emerging voices to wider audiences.",
  },
  {
    name: "Yasemin Solu",
    image: "/founders/yasemin.jpg",
    bio: "I grew up in Istanbul, a city where culture, emotion, and visual expression are constantly in dialogue — and that's where my connection to art first took shape. I went on to study Media Communications and Digital Marketing at Regent's University London, where I developed a deeper understanding of how storytelling influences creative experience. Working within London's creative community over the past several years allowed me to build a strong network of artists, cultural spaces, and brands, each shaping the way I approach connection, identity, and atmosphere. Today, I work independently as a creative marketing advisor, helping brands craft meaningful, experience-led moments rooted in narrative and presence.",
  },
];

export default function Founders() {
  return (
    <section
      id="founders"
      data-testid="founders-section"
      className="bg-[#FAFAFA] border-t border-black/10 py-24 md:py-40"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1 }}
          className="mb-16 md:mb-24 flex items-baseline justify-between"
        >
          <span className="label">The Collective</span>
          <span className="label hidden sm:inline">Three Voices</span>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10 lg:gap-16 max-w-5xl">
          {founders.map((f, i) => (
            <motion.article
              key={f.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1.1, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`founder-card-${i}`}
              className="flex flex-col"
            >
              <div className="overflow-hidden mb-8 aspect-[3/4] bg-[#EFEAE0] max-w-[280px]">
                <img
                  src={f.image}
                  alt={f.name}
                  className="img-mono w-full h-full object-cover transition-transform duration-[900ms] ease-out hover:scale-[1.03]"
                />
              </div>
              <h3
                className="font-heading text-2xl md:text-3xl tracking-tight text-black mb-5"
                data-testid={`founder-name-${i}`}
              >
                {f.name}
              </h3>
              <div className="h-px w-12 bg-black mb-6" />
              <p className="font-body font-light text-[15px] leading-relaxed text-black/75">
                {f.bio}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
